import type { UseHttp } from '~~/server/api/interface'

export const fetchCreateWXACode: UseHttp = (params, option) => {
  return useHttp.post('/api/wx/mini_app/wxa_code/create', params, { ...option })
}
export const fetchReverseGeocoding: UseHttp = (params, option) => {
  return useHttp.post(
    `/baidu_api/reverse_geocoding/v3/?ak=${baiduKey2}&output=json&coordtype=wgs84ll&location=${params?.latitude},${params?.longitude}`,
    undefined,
    { ...option }
  )
}
